"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapFloors = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_cirrus_store_1 = require("@yanzi/react-cirrus-store");
const Floor_1 = require("./Floor");
function MapFloors(_a) {
    var { baseUrl, floorLevel } = _a, props = __rest(_a, ["baseUrl", "floorLevel"]);
    const { data: manifest } = react_cirrus_store_1.useCirrusStoreGet(`${baseUrl}/manifest.json`);
    if (!manifest) {
        return null;
    }
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: Object.keys(manifest.floors)
            .filter(floor => Number(floor) === Number(floorLevel))
            .map(floorLevel => (jsx_runtime_1.jsx(Floor_1.Floor, Object.assign({ baseUrl: baseUrl, floorLevel: floorLevel }, props), floorLevel))) }, void 0));
}
exports.MapFloors = MapFloors;
//# sourceMappingURL=index.js.map